import React from 'react'

/**
 * Toast — transient confirmation bar pinned to the bottom-center on a
 * dark ink chip. Presentational: render it while a message is active.
 */
export function Toast({ kind = 'ok', children, className = '' }) {
  const cls = ['toast', kind === 'error' && 'toast-error', className].filter(Boolean).join(' ')
  return <div className={cls}>{children}</div>
}
